export const getGraphqlEndpoint = () => import.meta.env.PUBLIC_GRAPHQL_ENDPOINT;

export const getGraphqlPathname = () => {
  return new URL(import.meta.env.PUBLIC_GRAPHQL_ENDPOINT).pathname;
};

export const createSlug = (title: string) =>
  title
    .toLowerCase()
    // Replace special characters with spaces
    .replace(/[^a-z0-9\s-]/g, ' ')
    // Replace multiple spaces/hyphens with single hyphen
    .replace(/[\s-]+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '');

export const getIntegrations = async () => {
  const data = await import('../../scripts/data/integrations.json');
  return data.integrations;
};
